import { render, staticRenderFns } from "./BarCodeTemplate.vue?vue&type=template&id=51a04582&scoped=true&"
import script from "./BarCodeTemplate.vue?vue&type=script&lang=js&"
export * from "./BarCodeTemplate.vue?vue&type=script&lang=js&"
import style0 from "./BarCodeTemplate.vue?vue&type=style&index=0&id=51a04582&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a04582",
  null
  
)

export default component.exports